import {compress, decompress} from "compress-json"

export default {
    set(key, value) {
        if (value) {
            try {
                const compressedValue = compress(value)
                window.localStorage.setItem(key, JSON.stringify(compressedValue))
            } catch (e) {
                try {
                    const valueStr = JSON.stringify(value)
                    const val = JSON.parse(valueStr)
                    const compressedValue = compress(val)
                    window.localStorage.setItem(key, JSON.stringify(compressedValue))
                } catch (e) {
                    console.error('Failed to compress data:', e)
                }
            }
        } else {
            window.localStorage.removeItem(key)
        }
    },
    get(key, defaultVal = null) {
        const val = window.localStorage.getItem(key)
        if (!val) {
            return defaultVal
        }
        try {
            // return JSON.parse((val))
            return decompress(JSON.parse(val))
        } catch (e) {
            return defaultVal
        }
    },
    rm(key) {
        window.localStorage.removeItem(key)
    },
    clear() {
        window.localStorage.clear()
    }
}
